import { render } from "./SettingsTab.vue?vue&type=template&id=5a7ceae6&ts=true"
import script from "./SettingsTab.vue?vue&type=script&lang=ts"
export * from "./SettingsTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__